import gsap from "gsap";

export default class DropdownController {
    constructor() {
        let button = this.button = document.querySelector('.js-dropdown-button');
        let content = this.content = document.querySelector('.js-dropdown-content');

        if (!this.button && !this.content) {
            return;
        }

        this.controller(button, content);
    }

    controller(button, content) {

        button.addEventListener('click', () => {

            button.classList.toggle("is-active");

        })
    }
}
